import React from 'react';
import { WINDOW_LABEL, fmtDate, fmtDateTime } from './constants';
import { StatusBadge, StatusSelect } from './shared';

const AppointmentsTab = ({ appts, onUpdateStatus, onOpenHistory }) => (
  <div className="bg-white border border-black/5 overflow-x-auto" data-testid="appointments-tab">
    <table className="w-full text-[13px]">
      <thead>
        <tr className="text-left text-[10px] tracking-[0.22em] text-[#6b6b6b] border-b border-black/10">
          <th className="px-4 py-3 font-semibold">CLIENT</th>
          <th className="px-4 py-3 font-semibold">CONTACT</th>
          <th className="px-4 py-3 font-semibold">SERVICE</th>
          <th className="px-4 py-3 font-semibold">DATE</th>
          <th className="px-4 py-3 font-semibold">WINDOW</th>
          <th className="px-4 py-3 font-semibold">RECEIVED</th>
          <th className="px-4 py-3 font-semibold">STATUS</th>
        </tr>
      </thead>
      <tbody>
        {appts.length === 0 && (
          <tr><td colSpan={7} className="text-center text-[#6b6b6b] py-10">No appointments yet.</td></tr>
        )}
        {appts.map((a) => (
          <tr key={a.id} className="border-b border-black/5 hover:bg-[#faf6f0]/60" data-testid={`appointment-row-${a.id}`}>
            <td className="px-4 py-3">
              <button
                onClick={() => onOpenHistory(a.email)}
                className="font-semibold text-[#1c1e20] hover:text-[#c9a961] transition-colors text-left"
                data-testid={`open-history-${a.id}`}
              >
                {a.name}
              </button>
              {a.notes ? <p className="text-[#6b6b6b] text-[12px] mt-0.5 max-w-[220px] truncate italic">Note: {a.notes}</p> : null}
              {a.message ? <p className="text-[#6b6b6b] text-[12px] mt-0.5 max-w-[220px] truncate">{a.message}</p> : null}
            </td>
            <td className="px-4 py-3 text-[#3c3c3c]">
              <button onClick={() => onOpenHistory(a.email)} className="hover:text-[#c9a961]">{a.email}</button><br/>
              <a href={`tel:${a.phone}`} className="text-[12px] text-[#6b6b6b] hover:text-[#c9a961]">{a.phone}</a>
            </td>
            <td className="px-4 py-3 text-[#3c3c3c]">{a.service}</td>
            <td className="px-4 py-3 text-[#3c3c3c]">{fmtDate(a.date)}</td>
            <td className="px-4 py-3 text-[#3c3c3c] text-[12px]">{WINDOW_LABEL[a.time_window] || '—'}</td>
            <td className="px-4 py-3 text-[#6b6b6b] text-[12px]">{fmtDateTime(a.created_at)}</td>
            <td className="px-4 py-3">
              <div className="flex flex-col gap-1.5">
                <StatusBadge value={a.status} />
                <StatusSelect
                  value={a.status}
                  onChange={(s) => onUpdateStatus(a.id, s)}
                  testId={`appointment-status-select-${a.id}`}
                />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default AppointmentsTab;
